/* @sravni/react-design-system version 0.2.65 */
import { __assign } from 'tslib';
import * as React from 'react';
import { isBrowser, noop, safeInvoke } from '@sravni/react-utils';

/** Dialog or Sheet counter */
var openModalsCount = 0;
/** Window history offset */
var historyOffset = 0;
/**
 * React hook executes closeHandler on back browser button click (or software simulation), especially useful in the Sheet and Dialog on mobile devices
 *
 * @param enable enabling of the hook
 * @param visible current state of the modal
 * @param closeHandler handler to be executed when the modal closes
 * @returns closeEventHandler
 * @example
 * ```javascript
 * const { closeEventHandler } = useBackwardEvent(closeOnBackward, !!visible, handleClose)
 * ```
 */
function useBackwardEvent(enable, visible, closeHandler) {
    if (!isBrowser || !enable)
        return { closeEventHandler: noop };
    var modalIndex = React.useRef(0);
    var handleCloseOnBackward = function (event) {
        if (modalIndex.current === openModalsCount - 1) {
            safeInvoke(closeHandler, event);
            historyOffset = historyOffset - 1;
        }
    };
    var openEventHandler = function () {
        window.history.pushState(__assign({}, window.history.state), '');
        historyOffset = historyOffset + 1;
        openModalsCount = openModalsCount + 1;
    };
    var closeEventHandler = function () {
        openModalsCount = openModalsCount > 1 ? openModalsCount - 1 : 0;
        if (openModalsCount === 0) {
            historyOffset && window.history.go(0 - historyOffset);
            historyOffset = 0;
        }
    };
    React.useEffect(function () {
        if (visible) {
            modalIndex.current = openModalsCount;
            openEventHandler();
            window.addEventListener('popstate', handleCloseOnBackward);
        }
        else {
            window.removeEventListener('popstate', handleCloseOnBackward);
        }
        return function () { return window.removeEventListener('popstate', handleCloseOnBackward); };
    }, [visible]);
    return {
        closeEventHandler: closeEventHandler,
    };
}

export { useBackwardEvent };
//# sourceMappingURL=useBackwardEvent.js.map
